<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>        
        <v-col v-else id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <!-- <v-snackbar v-model="alert" :top="true" color="error">{{ alertmensaje }}</v-snackbar> -->
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'order'})" icon  :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>

            <v-row v-if="metodo_envio == 'Entrega a domicilio'" class="RestoRegular mt-5 pl-6 mb-4" style="height:20px; font-size: 20px; color: #4D4D4D;">
                Donde se va a entregar
            </v-row>

            <v-row v-else class="RestoRegular mt-5 pl-6 mb-4" style="height:20px; font-size: 20px; color: #4D4D4D;">
                Donde lo recoges
            </v-row>

            <!-- Order Card -->
            <v-row>
                <v-col style="width: 100%" class="pt-0">

                    <v-row justify="start" align="center"  class="pt-0" style="width: 95%; margin: 0 auto; background-color: #E6E6E6; border-radius: 5px">
                        <v-col align-self="center" cols="auto">
                            <v-img v-if="metodo_envio == 'Entrega a domicilio'" src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                            <v-img v-else src="@/assets/resources/user/restaurante.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col  v-if="metodo_envio == 'Entrega a domicilio'" align-self="center" style="font-size: 12px" class="RestoRegular">
                            <v-row class="RestoBold" style="font-size: 13px">
                                {{address.alias}}
                            </v-row>
                            <v-row>
                                {{address.calle}} {{address.num_exterior}} {{address.num_interior}} {{address.colonia}} CP {{address.cp}}
                            </v-row>
                        </v-col>    
                        <v-col  v-else align-self="center" style="font-size: 12px" class="RestoRegular">
                            <v-row class="RestoBold" style="font-size: 13px">
                                {{sucursal.sucursal}}
                            </v-row>
                            <v-row>
                                {{sucursal.calle}} #{{sucursal.num_exterior}}, {{sucursal.ciudad}}
                            </v-row>
                        </v-col>             
                    </v-row>

                    <v-row v-if="metodo_envio == 'Recoger en restaurante'" align="center" justify="end" class="mt-2" style="height: auto; width: 95%; margin: 0 auto; ">
                        <v-col cols="auto">
                            <v-row justify="center" align="center" style="color: #4d4d4d; font-size: 20px" class="RestoRegular pr-2">
                                Lo recojo a las: 
                            </v-row>
                        </v-col>
                        <v-col style="position: relative;" class="">
                            <v-row align="center" justify="center" style="min-height: 35px; color: #4d4d4d; " class="RestoRegular">
                                    <select v-model="horario_recoger" style="z-index: 2;  widht: 100%">
                                        <option value="00:00">-- Seleccione --</option>
                                        <option  v-for="hour in hours" :key="hour.in" :value="hour">
                                            {{hour}}
                                        </option>
                                    </select>
                            </v-row>
                            <v-row align="start" justify="end" style=" position: absolute; top: 18px; right: 5%; z-index: -11" >
                                <v-img max-width="20px" src="@/assets/resources/menu/icon_arrow_unfold.png"></v-img>
                            </v-row>
                        </v-col>
                    </v-row>


                    <v-row class="RestoRegular mt-5 pl-6 mb-4" style="height:20px; font-size: 20px; color: #4D4D4D;">
                        Elige tu método de pago
                    </v-row>
                    <v-row  justify="center" class="mb-2">
                        <v-btn @click="goTo" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                            Agregar nuevo método de pago
                        </v-btn>
                    </v-row>
                    <v-row align="center" justify="end" style="height: auto;">
                        <v-col style="position: relative;" class="">
                            <v-row align="center" justify="center" style="min-height: 35px; color: #4d4d4d; " class="RestoRegular">
                                <form action="" method="post" id="pay" name="pay" style="width: 70%; margin: 0 auto;">
                                    <label v-show="false">Payment Method:</label>
                                    <select @change="getCVV" v-model="selectedCard" id="cardId" name="cardId" data-checkout='cardId' style="z-index: 2;  widht: 100%">
                                        <option value="">-- Seleccione --</option>
                                        <option  v-for="card in cards" :key="card.in" :value="card.id_tarjeta"  
                                            :first_six_digits="card.digitos_inicial"
                                            security_code_length="3">
                                            Tarjeta terminada en {{card.digitos_final}}
                                        </option>
                                    </select>
                                    <v-text-field
                                        :maxlength="maxCVV"
                                        v-model="cvv"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        label="CVV"
                                        :rules="[rules.required,rules.cvv]"
                                        outlined
                                        id="cvv4"
                                        class="mt-1 mb-2"
                                        hide-details='true'
                                        @click:append="showPassword = !showPassword"
                                    ></v-text-field>
                                    <li v-show="false"  id="cvv">
                                        <label for="cvv">Security code:</label>
                                        <input v-model="cvv" type="text" id="cvv" data-checkout="securityCode" placeholder="" />
                                    </li>
                                <input v-show="false" type="submit" value="Pagar"/>
                                </form>
                            </v-row>
                            <v-row align="start" justify="end" style=" position: absolute; top: 18px; right: 20%; z-index: -11" >
                                <v-img max-width="20px" src="@/assets/resources/menu/icon_arrow_unfold.png"></v-img>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- <form action="" method="post" id="pay" name="pay" >
                        <label v-show="false">Payment Method:</label>
                        <select id="cardId" name="cardId" data-checkout='cardId'>
                            <option value="">-- seleccione --</option>
                            <option v-for="card in cards" :key="card.in" :value="card.id_tarjeta"  
                                :first_six_digits="card.digitos_inicial"
                                security_code_length="3">
                                Tarjeta terminada en {{card.digitos_final}}
                            </option>
                        </select>
                    <li v-show="false" id="cvv">
                        <label for="cvv">Security code:</label>
                        <input type="text" id="cvv" data-checkout="securityCode" placeholder="123" />
                    </li>
                    <input v-show="false" type="submit" value="Pagar"/>
                    </form> -->
                    <v-btn v-show="false" @click="generateToken">Pagar</v-btn>
                    <v-row justify="center" class="pr-0 mb-2 RestoBold" style="font-size: 15px; text-align: center">
                        Tus transacciones están seguras y encriptadas
                    </v-row> 
                    <v-row justify="center" class="pr-6 mb-6">
                        <v-img src="@/assets/resources/yoomi/MP.png" max-width="100px"></v-img>
                    </v-row> 
                    
                    <v-row justify="center" class="pr-0 mb-2 mt-4">
                        <v-btn @click="generateToken" :loading="loading" color="green" large style="color: white; width: 85%; max-width: 262px;" class="buttonLower">
                            Pagar con tarjeta
                        </v-btn>
                    </v-row>
                    <v-row v-if="paymentCT()" justify="center" style="font-size: 22px" class="RestoRegular">
                        ó
                    </v-row>
                    <v-row v-if="paymentCT()" justify="center" class="pr-0 mb-0 RestoRegular" style="font-size: 15px">
                        Pago contra entrega
                    </v-row> 
                    <v-row justify="center" class="pr-0 mt-0 pt-0" style="width: 85%; max-width: 262px; margin: 0 auto">
                        <v-col v-if="cashBandera()">
                            <v-row class="">
                                <v-btn  @click="payCash('Efectivo')" :loading="loadingPCE" color="green" large style="color: white; width: 100%" class="buttonLower">
                                    Efectivo
                                </v-btn>
                            </v-row>
                        </v-col>

                        <v-col cols="1" v-if="space()">
                        </v-col>
                        
                        <v-col v-if="terminalBandera()">
                            <v-row class="">
                                <v-btn  @click="payCash('Terminal')" :loading="loadingPCE" color="green" large style="color: white; width: 100%" class="buttonLower">
                                    Terminal
                                </v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                    
                    <v-row v-show="false" justify="center" align="start" style="width: 95%; margin: 0 auto">
                        <v-col>
                            <v-row v-for="(payment, index) in payments" :key="index" style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                            <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-4" cols="3">
                                    <v-row class="RestoBold" style="font-size: 13px;">
                                        {{payment.alias}}
                                    </v-row>
                                </v-col>
                                <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-2">
                                    <v-row >
                                        {{payment.digitos_inicial}} ****** {{payment.digitos_final}}
                                    </v-row>
                                    
                                </v-col>
                                <v-col align-self="center" cols="auto">
                                    <a style="font-size: 14px; background-color: transparent; color: red" class="RestoBold">
                                        Eliminar
                                    </a>
                                </v-col>
                            </v-row>

                            <v-row style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                            <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-4" cols="3">
                                    <v-row class="RestoBold" style="font-size: 13px;">
                                        Pago contra entrega
                                    </v-row>
                                </v-col>
                                <v-col align-self="center" style="font-size: 12px;" class="RestoRegular">
                                    <v-row >
                                        
                                    </v-row>
                                    
                                </v-col>
                                <v-col align-self="center">
                                    
                                </v-col>
                                <v-col align-self="center" cols="auto"  class="my-0 py-0">
                                    <v-radio-group v-model="active" class="my.0 py-0">
                                        <v-radio :color="$store.state.colors.primary"  value="efectivo" class="my-0 py-0">
                                        </v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>

                            <v-row style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                                <v-col align-self="center" style="font-size: 12px;" class="RestoRegular ml-4" cols="10">
                                    <v-row class="RestoBold" style="font-size: 13px;">
                                        Instrucciones de Entrega
                                    </v-row>
                                </v-col>
                                <!-- <v-col align-self="center" style="font-size: 12px;" class="RestoRegular">
                                    <v-row >
                                        
                                    </v-row>
                                    
                                </v-col> -->
                                <v-col align-self="center">
                                    
                                </v-col>
                                <v-col align-self="center" cols="12" rows="1" class="my-0 py-0 pl-4 pr-4">
                                    <v-textarea v-model="deliveryInstructions" outlined  rows="1"> 

                                    </v-textarea>
                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                    <v-row v-show="false" justify="end" style=" width: 95%; margin: 0 auto;" class="pr-4 pb-4">
                        <v-btn @click="createdOrder()" :color="$store.state.colors.primary" dense rounded class="buttonLower ml-2" style="color: white; height: 30px; width: 120px; font-size: 12px">Pagar</v-btn>
                    </v-row>

                </v-col>
            </v-row>
            <v-dialog
                v-model="dialog"
                max-width="400"
                persistent
                >
                <v-card>
                    <v-row justify="center" align="center" style="color: white">
                        <v-col calign-self="center" cols="auto">
                            <v-row justify="center" >
                                <v-img src="@/assets/resources/yoomi/happy-sad.png" max-width="80px"></v-img>
                            </v-row> 
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 25px;" :style="{ 'color': $store.state.colors.primary }">
                                ¡OH NO!
                            </v-row>  
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; height:20px;">
                                Al parecer algo ha ido mal 
                            </v-row>
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; height:20px;">
                                con tú método de pago
                            </v-row>
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; height:20px;">
                            </v-row>
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 14px;color:#4D4D4D; height:20px;">
                                Te sugerimos cambiar tu método de 
                            </v-row>
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 14px;color:#4D4D4D; height:20px;">
                                pago o intentar realizar tu pedido
                            </v-row>
                            <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 14px;color:#4D4D4D; height:20px;">
                                más tarde
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="pr-2">
                        <v-col calign-self="center" cols="auto">
                            <v-row justify="center" >
                                <v-btn @click="changeMethod" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                                    Cambiar método
                                </v-btn>
                            </v-row> 
                        </v-col>                      
                    </v-row>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogTO" max-width="400" persistent>
                <v-card>
                    <v-row justify="center" align="center" style="color: white">
                        <v-col cols="auto">
                            <v-row justify="center" >
                                <v-img src="@/assets/resources/yoomi/happy-sad.png" max-width="80px"></v-img>
                            </v-row> 
                            <v-row justify="center" class="pb-0 mb-0 pt-0 mt-4 RestoRegular" style="font-size: 25px;" :style="{ 'color': $store.state.colors.primary }">
                                ¡OH NO!
                            </v-row>  
                            <v-row justify="center" class="pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 15px">
                                La transacción tomó más
                            </v-row>
                            <v-row justify="center" class="py-0 my-0 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 20px">
                                tiempo de lo esperado
                            </v-row>
                            <v-row justify="center" class="pb-0 mb-0 mt-2 RestoRegular" style="font-size: 14px;color:#4D4D4D; ">
                                Por favor valida que tu pedido haya sido
                            </v-row>
                            <v-row justify="center" class="pb-0 mb-0 RestoRegular" style="font-size: 14px;color:#4D4D4D; ">
                                creado en al sección de Pedidos antes
                            </v-row>
                            <v-row justify="center" class="pb-0 mb-0 RestoRegular" style="font-size: 14px;color:#4D4D4D; ">
                                de intentar pagar nuevamente
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="mt-0">
                        <v-col calign-self="center" cols="auto">
                            <v-row justify="center" >
                                <v-btn @click="dialogTO = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                                    Entendido
                                </v-btn>
                            </v-row> 
                        </v-col>                      
                    </v-row>
                </v-card>
            </v-dialog>
                
            <v-dialog
                v-model="finishDialog"
                max-width="290"
                persistent
                overlay-opacity="0.5"
            >
                <v-card loading>
                    <!-- <v-card-title class="headline"><span>¿Deseas cambiar de <br> dirección?</span></v-card-title> -->
                    <v-card-title>
                        Procesando compra
                    </v-card-title>
                    <v-card-subtitle>
                        Ejecutando transaccion de manera segura en Mercado Pago
                    </v-card-subtitle>
                    <!-- <v-card-text class="RestoBold"  >
                    Si decides cambiar de dirección tu pedido actual se perderá ¿Deseas continuar?
                    </v-card-text> -->
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="finishDialogC"
                max-width="290"
                persistent
                overlay-opacity="0.5"
            >
                <v-card loading>
                    <!-- <v-card-title class="headline"><span>¿Deseas cambiar de <br> dirección?</span></v-card-title> -->
                    <v-card-title>
                        Procesando compra
                    </v-card-title>
                    <!-- <v-card-text class="RestoBold"  >
                    Si decides cambiar de dirección tu pedido actual se perderá ¿Deseas continuar?
                    </v-card-text> -->
                </v-card>
            </v-dialog>
        </v-col>
        <!-- <v-dialog v-model="dialogP" max-width="310">
            <v-card>
                <v-col>
                    <v-row justify="center" style="font-size: 25px; text-align: center; line-height: 29px; width: 80%; margin: 0 auto">
                        Esto hará que tu pedido se pierda
                    </v-row>
                    <v-row justify="center" class="RestoBold mt-2 mb-4" style="font-size: 18px; text-align: center; line-height: 18px; width: 80%; margin: 0 auto">
                        ¿Deseas continuar?
                    </v-row>
                </v-col>
                
                 <v-card-title style="font-size: 32px"><span>Esto hará que tu pedido se pierda</span></v-card-title>
                <v-card-text style="font-size: 28px">
                ¿Estás de acuerdo?
                </v-card-text> 

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialogP = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="goTo(); dialogP = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </v-row>
</template>


<script>
import axios from 'axios';
export default {
    data() {
        return {
            horario_recoger: "00:00",
            hours: [],
            dialogTO: false,
            sucursal: {},
            metodo_envio: localStorage.getItem("metodo_envio"),
            finishDialog: false,
            finishDialogC: false,
            loadingPCE: false,
            loading: false,
            cvv: "",
            maxCVV: null,
            showPassword: false,
            rules: {
                card: v =>
                v
                    ? (v.length >= 18 && v.length <= 19) ||
                    "Minimo 15 caracteres máximo 16"
                    : true,
                exp: v => (v ? v.length >= 5 || "Coloca la expiración completa" : true),
                cvv: v =>
                v
                    ? (v.length >= 3 && v.length <= 4) || "Minimo 3 caracteres máximo 4"
                    : true,
                required: value => !!value || ""
            },
            selectedCard: "",
            deliveryInstructions: "",
            // dialogP: false,
            dialog:false,
            address:JSON.parse(localStorage.getItem("addressUser")),
            idOrder:null,
            addresses: null,
            platillos: this.$store.state.lista_platillos,
            payments:null,
            active: "Banamex",
            payMethod:null,
            methodPay:'',
            cards: null,
            validateLoad:true,
        }
    },
    mounted() {
        var that = this;  
        var doSubmit = false;
        var key = "";
        var entorno;
        if(localStorage.getItem("id_sucursal") == "1" || localStorage.getItem("id_sucursal") == "3" || localStorage.getItem("id_sucursal") == "7" || localStorage.getItem("id_sucursal") == "4"
        || localStorage.getItem("id_sucursal") == "5"  || localStorage.getItem("id_sucursal") == "8"  || localStorage.getItem("id_sucursal") == "9"  || localStorage.getItem("id_sucursal") == "10"
        || localStorage.getItem("id_sucursal") == "11"  || localStorage.getItem("id_sucursal") == "12"  || localStorage.getItem("id_sucursal") == "13"  || localStorage.getItem("id_sucursal") == "14"
        || localStorage.getItem("id_sucursal") == "15")
            entorno = "Productivo";
        else 
        {
            entorno = "Sandbox"
            console.log(entorno)
        }
            
        axios.get('/tokenML/' + localStorage.getItem("id_sucursal")+'/' + entorno, { headers: {Authorization: localStorage.getItem("token")} }).then(response => {
        //   console.log(response);
            // console.log(response);
            key = response.data[0].valor;
            // console.log(key);
            window.Mercadopago.setPublishableKey(key);

        }).catch(err => { console.log(err);})

        axios.get('/datos_b_c/' + localStorage.getItem("id_cliente") + '/' + localStorage.getItem("id_sucursal"), { headers: {Authorization: localStorage.getItem("token")} }).then(response => {
        //   console.log(response);
            // console.log(response);
            // console.log("ENTRANDO")
            localStorage.setItem("formas_aceptadas", response.data.formas_aceptadas);
            that.cards = response.data.tarjetas
            localStorage.setItem('userCards', JSON.stringify(response.data.tarjetas));
            // localStorage.set('userCards', )
            this.$store.state.userCards = response.data.tarjetas;
            // console.log(that.cards);
        }).catch(err => { console.log(err);})


        document.querySelector('#pay').addEventListener('submit', doPay);

        function doPay(event){
            event.preventDefault();
            if(!doSubmit){
                var $form = document.querySelector('#pay');

                window.Mercadopago.createToken($form, sdkResponseHandler);

                return false;
            }
        }

        function sdkResponseHandler(status, response) {
            if (status != 200 && status != 201) {
                alert("verify filled data");
            }else{
                var form = document.querySelector('#pay');
                var card = document.createElement('input');
                card.setAttribute('name', 'token');
                card.setAttribute('type', 'hidden');
                card.setAttribute('value', response.id);
                form.appendChild(card);
                doSubmit=true;
            }
        }
    },
    created() {
        var minHour
        var date = new Date;
        var minutes = date.getMinutes();
        var hora = date.getHours();        
        if(minutes < 30 && minutes > 0)
            minutes = 30
        else if(minutes > 30)
            minutes = 60;
        if(minutes == 60)
            {hora++; minutes = 0}
        hora++;
        // console.log("Min", hora, minutes)
        if(minutes == 30)
            minHour = hora + 0.5;
        else
            minHour = hora;

        // var minHour = "8:30:00";
        // var a = minHour.split(':'); 
        // minHour = parseInt(a[0]);
        
        // console.log(localStorage.getItem("addressUser"));
        // console.log("PARAMETROS RUTEO: ", this.$route.params);
        // console.log(this.address);
        this.idOrder=this.$route.params.id;
        this.$store.state.hideFooter = false;
        // console.log("EL OBJETO PLATILLO: ",this.$store.state.lista_platillos);
        this.$store.dispatch("GET", {url: '/datos_b_c/' + localStorage.getItem("id_cliente") + '/' + localStorage.getItem("id_sucursal"), headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                console.log(response);
                this.sucursal = response.data.direccion_sucursal;
                var maxHour = response.data.direccion_sucursal.cierre;
                var a = maxHour.split(':'); 

                if(a[1] == "30")
                    maxHour = parseInt(a[0]) + 0.5;
                else
                    maxHour = parseInt(a[0]);

                var hours = [];
                for(var hour = minHour; hour < maxHour-0.5; hour+= 0.5)
                {
                    if(!Number.isInteger(hour))
                        hours.push(parseInt(hour).toString() + ":30");
                    else
                        hours.push(hour.toString() + ":00");
                }
                this.hours = hours;

                console.log("Horario", hours);
                // console.log(response.data.formas_aceptadas);
                localStorage.setItem("formas_aceptadas", response.data.formas_aceptadas);
                this.methodPay='Tarjeta Credito'
                this.payments = response.data.tarjetas;
                // console.log(this.payments)
                for(var i=0;i<this.payments.length;i++)
                {
                    if(this.payments[i].digitos_inicial==null)
                    {
                        this.payments[i].digitos_inicial='XXXXXX'
                    }
                    if(this.payments[i].digitos_final==null)
                    {
                        this.payments[i].digitos_final='XXXX'
                    }
                }
                this.validateLoad = false;
            })
            .catch(error => {
                console.log("Error: " + error);
            });
    },
    watch:{
        active()
        {
            // console.log(this.active);
            for(var i=0;i<this.payments.length;i++)
            {
                if(this.payments[i].alias==this.active&&this.active!='efectivo')
                {
                    this.payMethod=this.payments[i];
                    this.methodPay='Tarjeta Credito'
                    // console.log(this.payMethod);
                }
                if(this.active=='efectivo')
                {
                    this.payMethod=null;
                    this.methodPay='efectivo';
                }
            }
        }
    },
    methods: {
        cashBandera() {
            if(this.metodo_envio == 'Recoger en restaurante')
                return false
            else
            {
                if(localStorage.getItem('formas_aceptadas') == 'A' || localStorage.getItem('formas_aceptadas') == 'E' ) 
                    return true;
                else   
                    return false;
            }
            
        },
        terminalBandera() {
            if(this.metodo_envio == 'Recoger en restaurante')
                return false
            else
            {
                if(localStorage.getItem('formas_aceptadas') == 'A' || localStorage.getItem('formas_aceptadas') == 'T' ) 
                    return true;
                else   
                    return false;
            }
        },
        space(){
            if(this.metodo_envio == 'Recoger en restaurante')
                return false
            else
            {
                if(localStorage.getItem('formas_aceptadas') == 'A')
                    return true;
                else
                    return false;
            }
        },
        paymentCT(){
            if(this.metodo_envio == 'Recoger en restaurante')
                return false
            else
            {
                if(localStorage.getItem('formas_aceptadas') == 'A' || localStorage.getItem('formas_aceptadas') == 'E' || localStorage.getItem('formas_aceptadas') == 'T')
                    return true;
                else
                    return false;
            }
        },
        changeMethod(){
            this.dialog=false; 
            location.reload();
        },
        goTo(){
            this.$router.push({name: 'newPaymentMethod'});
        },
        maskCard(card){
            var res = card.replace(/-/g, '');
            return res.length==16 ? res.substr(res.length - 4) : res.substr(res.length - 3);
        },
        generateToken() {
            if(this.horario_recoger != "00:00" || this.metodo_envio == "Entrega a domicilio")
            {
                this.loading = true;
                this.finishDialog = true;
                var _this = this;
                // var text = "Hola";
                var address = this.address.id_direccion;
                // var methodPay = this.methodPay;
                var refe = this;
                var lista_platillos = this.$store.state.lista_platillos;
                var $form = document.querySelector('#pay');
                window.Mercadopago.createToken($form, function (status, response) {
                if (status != 200 && status != 201) {
                    _this.loading = false;
                    _this.finishDialog = false;
                    alert("Verificar tus datos ingresados");
                }else{
                    // console.log(text);
                    var form = document.querySelector('#pay');
                    var card = document.createElement('input');
                    card.setAttribute('name', 'token');
                    card.setAttribute('type', 'hidden');
                    card.setAttribute('value', response.id);
                    form.appendChild(card);
                    // console.log(response.id);

                    var order={
                        id_cliente:localStorage.getItem("id_cliente"),
                        id_sucursal:localStorage.getItem("id_sucursal"),
                        id_direccion:address,
                        monto_total:localStorage.getItem("amount"),
                        comentarios:localStorage.getItem('comentarios'),
                        metodo_entrega: localStorage.getItem('metodo_envio'),
                        token_tc: response.id,
                        descripcion_pago:"Consumo Alimentos " + localStorage.getItem('codigo_marca').toUpperCase(),
                        metodo_pago:"Tarjeta Credito",
                        propina: localStorage.getItem("propina"),
                        platillos:lista_platillos, 
                        horario_recoge: this.horario_recoger,
                    };

                    localStorage.setItem("Orden",JSON.stringify(order));
                    console.log("SENDING", order);
                    
                    axios.post('/alta_pedido', order, { headers: { Authorization: localStorage.getItem("token") }, timeout: 60000 } )
                        .then(res =>{
                            console.log(res);
                            if(res.data.mensaje != "Pedido creado")
                            {
                                refe.loading = false;
                                refe.finishDialog = false;
                                refe.dialog=true;
                                console.log(refe.$store.state.lista_platillos);
                            }
                            else{
                                localStorage.setItem("nombre_cliente", res.data.nombre_cliente)
                                refe.loading = false;
                                refe.finishDialog = false;
                                refe.$store.state.lista_platillos = [];
                                refe.$store.state.finishedData = res.data;
                                console.log( refe.$store.state.finishedData );
                                localStorage.removeItem('comentarios'); 
                                localStorage.removeItem('metodo_envio');
                                localStorage.setItem('platillos', JSON.stringify([]));
                                refe.$router.push({ name: 'finished', params: {id_pedido: res.data.id_pedido, sucursal: res.data.sucursal, horario_recoge: refe.horario_recoger}})
                            } 
                        })
                        .catch(error => {
                            refe.loading = false;
                            refe.finishDialog = false;
                            refe.dialogTO = true;
                            console.log(error)}
                        );
                    }
                
            });
                return false;
            }
        },
        getCVV()
        {
            var s = document.getElementById("cardId");
            // console.log(s.selectedIndex-1, this.cards[s.selectedIndex-1].tipo_tarjeta)
            // this.$router.push({name: 'order', params: {platillo: this.$store.state.lista_platillos}});
            // this.$nextTick(() => {
            //     location.reload();
            // });
            if(this.cards[s.selectedIndex-1].tipo_tarjeta == 'Master')
                this.maxCVV = 3;
            else if(this.cards[s.selectedIndex-1].tipo_tarjeta == 'American Express')
                this.maxCVV = 4;
            else 
                this.maxCVV = 3;
            this.cvv = "";
        },

        payCash(val) {
            this.loadingPCE = true;
            this.finishDialogC = true;
            var order={
                    id_cliente:localStorage.getItem("id_cliente"),
                    id_sucursal:localStorage.getItem("id_sucursal"),
                    id_direccion:this.address.id_direccion,
                    monto_total:localStorage.getItem("amount"),
                    comentarios:localStorage.getItem('comentarios'),
                    metodo_entrega: localStorage.getItem('metodo_envio'),
                    token_tc: "",
                    descripcion_pago:"Consumo Alimentos " + localStorage.getItem('codigo_marca').toUpperCase() ,
                    metodo_pago:val,
                    propina: localStorage.getItem("propina"),
                    platillos: this.$store.state.lista_platillos, 
                    horario_recoge: this.horario_recoger,
                };

                localStorage.setItem("Orden",JSON.stringify(order));
                console.log("SENDING", order);
                axios.post('/alta_pedido', order, {headers: {Authorization: localStorage.getItem("token") }, timeout: 60000 })
                    .then(res =>{
                        console.log(res);
                        if(res.data.mensaje=="No se creo el pedido")
                        {
                            this.loadingPCE = false;
                            this.finishDialogC = false;
                            this.dialog=true;
                            // console.log(this.$store.state.lista_platillos);
                        }
                        else{
                            localStorage.setItem("nombre_cliente", res.data.nombre_cliente)
                            this.loadingPCE = false;
                            this.finishDialogC = false;
                            this.$store.state.lista_platillos = [];
                            localStorage.removeItem('comentarios'); 
                            localStorage.removeItem('metodo_envio');
                            this.$store.state.finishedData = res.data;
                            this.$router.push({ name: 'finished', params: {id_pedido: res.data.id_pedido, sucursal: res.data.sucursal, horario_recoge: this.horario_recoger} })
                        } 
                    })
                    .catch(error => {
                        this.loadingPCE = false;
                        this.finishDialogC = false;
                        this.dialogTO = true;
                        console.log(error)}
                    );
        },
        async createdOrder()
        {
            // console.log(this.address);
            var order={
                id_cliente:localStorage.getItem("id_cliente"),
                id_sucursal:localStorage.getItem("id_sucursal"),
                id_direccion:this.address.id_direccion,
                monto_total:localStorage.getItem("amount"),
                comentarios:localStorage.getItem('comentarios'),
                metodo_entrega: localStorage.getItem('metodo_envio'),
                metodo_pago:this.methodPay,
                propina: this.$store.state.propina,
                platillos:this.$store.state.lista_platillos, 
                horario_recoge: this.horario_recoger,
/*                 id_cliente:"9",
                id_sucursal:"1",
                id_dirección:"1",
                monto_total:"605",
                comentarios:"",
                metodo_entrega:"Entrega a domicilio",
                metodo_pago:"Tarjeta Credito",
                platillos:[
                    {
                        id_platillo:"58",
                        cantidad:"1",
                        precio_unitario:"550.00",
                        adicionales:[{
                            id_adicional:"2",
                            cantidad:"1",
                        }],
                        modificadores:[{
                            id_modificador:"2",
                            cantidad:"1",
                        }],                       
                    }
                ], */
            };
            localStorage.setItem("Orden",JSON.stringify(order));
            // console.log(order);
            await axios.post('/alta_pedido', order, {headers: {Authorization: this.$store.state.token}, timeout: 60000 })
                .then(res =>{
                    // console.log(res);
                    if(res.data.mensaje=="No se creo el pedido")
                    {
                        this.dialog=true;
                        console.log(this.$store.state.lista_platillos);
                    }
                    else{
                        localStorage.setItem("nombre_cliente", res.data.nombre_cliente)
                        this.$store.state.finishedData = res.data;
                        localStorage.removeItem('metodo_envio');
                        this.$store.state.lista_platillos = [];
                        this.$router.push({ name: 'finished'})
                    } 
                })
                .catch(error => {
                    console.log(error)}
                );
        }
    }
}
</script>

<style scoped>
    .rounded-btn{
       border-radius:20px;
    }

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .active {
        color: white;
    }
    .a:hover 
    { 
    background-color:  #E6E6E6;
    } 

    select {
        width: 100%;
        padding: 5px 20px;
        border: none;
        border-radius: 4px;
        background-color: transparent;
    }

</style>